import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "logo" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Лицензии ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Лицензии ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_KeyOutlined = _resolveComponent("KeyOutlined")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_TeamOutlined = _resolveComponent("TeamOutlined")!
  const _component_VerifiedOutlined = _resolveComponent("VerifiedOutlined")!
  const _component_a_menu_divider = _resolveComponent("a-menu-divider")!
  const _component_CloudServerOutlined = _resolveComponent("CloudServerOutlined")!
  const _component_VideoCameraOutlined = _resolveComponent("VideoCameraOutlined")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_DownloadOutlined = _resolveComponent("DownloadOutlined")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!

  return (_openBlock(), _createBlock(_component_a_layout_sider, {
    collapsed: _ctx.collapsed,
    "onUpdate:collapsed": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.collapsed) = $event)),
    collapsible: "",
    breakpoint: "lg",
    width: "300"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_link, { to: { name: 'Instances' } }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _ctx.collapsed ? '/img/logo_light_mini.svg' : '/img/logo_light_full.svg'
            }, null, 8, _hoisted_2)
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_a_menu, {
        openKeys: _ctx.openKeys,
        "onUpdate:openKeys": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.openKeys) = $event)),
        selectedKeys: _ctx.selectedKeys,
        "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedKeys) = $event)),
        mode: "inline",
        theme: "dark"
      }, {
        default: _withCtx(() => [
          (_ctx.userRole === 'Admin')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_a_menu_item, { key: "/alllicenses" }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_KeyOutlined)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: { name: 'Licenses-All' } }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_menu_item, { key: "/users" }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_TeamOutlined)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: { name: 'Users' } }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('Anticolumbine.Interface.Users.ShortTitle')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ], 64))
            : (_ctx.userRole === 'Partner')
              ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "/licenses" }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_KeyOutlined)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: { name: 'Licenses' } }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createVNode(_component_a_menu_item, { key: "/instances" }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_VerifiedOutlined)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, { to: { name: 'Instances' } }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('Anticolumbine.Interface.Instances.Index.Title')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.instancesLoaded && _ctx.instances.length > 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_a_menu_divider),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instances, (instance) => {
                          return (_openBlock(), _createBlock(_component_a_sub_menu, {
                            key: instance.id.toString()
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_CloudServerOutlined)
                            ]),
                            title: _withCtx(() => [
                              _createTextVNode(_toDisplayString(instance.description), 1)
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(), _createBlock(_component_a_menu_item, {
                                key: `/instance/incidents/${instance.id}`
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_component_VideoCameraOutlined)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_router_link, {
                                    to: { name: 'Instance-Incidents', params: { id: instance.id } }
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('Anticolumbine.Interface.Instances.Gallery.ShortTitle')), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]),
                                _: 2
                              }, 1024)),
                              (_openBlock(), _createBlock(_component_a_menu_item, {
                                key: `/instance/details/${instance.id}`
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_component_KeyOutlined)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_router_link, {
                                    to: { name: 'Instance-Details', params: { id: instance.id } }
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('Anticolumbine.Interface.Instances.Details.ShortTitle')), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]),
                                _: 2
                              }, 1024))
                            ]),
                            _: 2
                          }, 1024))
                        }), 128)),
                        _createVNode(_component_a_menu_divider)
                      ], 64))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_menu_item, { key: "/download" }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_DownloadOutlined)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, { to: { name: 'Download' } }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('Anticolumbine.Interface.Download.ShortTitle')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ], 64))
        ]),
        _: 1
      }, 8, ["openKeys", "selectedKeys"])
    ]),
    _: 1
  }, 8, ["collapsed"]))
}